import type z from '@/lib/zod';
import { tabSearchSchema } from './tabSearchSchema';
import { tenantDetailSearchSchema } from './tenantDetailSearchSchema';

/**
 * Pagina dell'incaricato: tab e ricerca della lista dei tenant delegati e la
 * scheda del dettaglio tenant aperto sopra (`$id`, di default il Cassetto).
 */
export const appointeeSearchSchema = tabSearchSchema.extend(
  tenantDetailSearchSchema.shape
);

export type AppointeeSearch = z.output<typeof appointeeSearchSchema>;
